import { useAppSelector } from 'app/store'
import withProgress from 'core/components/progress/withProgress'
import Dropdown from 'core/elements/dropdown'
import useListAction from 'core/hooks/useListAction'
import React, { useMemo } from 'react'
import { listTemplates } from '../../repositories/actions'
import { templateSelector } from '../../repositories/selector'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

export default function TemplatetPicklist({
  disabled = false,
  name = 'template',
  label = 'Template',
  networkId = null,
  includeNoneOption = false,
  value,
  ...rest
}) {
  const { loading } = useListAction(listTemplates)
  const templateDetails = useAppSelector(templateSelector)
  const options = useMemo(() => {
    if (!Array.isArray(templateDetails)) return []

    const templateOptions = templateDetails?.map((item) => ({
      label: item?.headerName || item?.uid, // fallback to uid if headerName is missing
      value: item?.uid,
    }))

    return includeNoneOption
      ? [{ label: 'None', value: null }, ...templateOptions]
      : templateOptions
  }, [templateDetails, includeNoneOption])

  return (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loading}
      items={options}
      value={value}
    />
  )
}
